import { render, staticRenderFns } from "./magic.vue?vue&type=template&id=dd57b588&scoped=true&"
import script from "./magic.vue?vue&type=script&lang=js&"
export * from "./magic.vue?vue&type=script&lang=js&"
import style0 from "./magic.vue?vue&type=style&index=0&id=dd57b588&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd57b588",
  null
  
)

export default component.exports